// StickyCTA
(() => {
  const sticky = document.getElementById('StickyATC');
  const jsonEl = document.getElementById('FeaturedProductJson');
  if (!sticky || !jsonEl) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent.trim());
  } catch (e) {
    console.error('Sticky ATC: Failed to parse FeaturedProductJson', e);
    return;
  }

  const variantSelect = document.getElementById('StickyVariant');
  const qtyInput = document.getElementById('StickyQty');
  const submitBtn = document.getElementById('StickySubmit');
  const priceWrap = sticky.querySelector('[data-sticky-price]');

  // Optional: show/hide only after scrolling past a target area
  const anchor =
    document.querySelector('.product-form__buttons') ||
    document.querySelector('[data-product-form]') ||
    document.querySelector('#AddToCart') ||
    null;

  const moneyFormat = window.__MONEY_FORMAT__ || '$';

  const formatMoney = (cents) => {
    const n = Number(cents);
    if (Number.isNaN(n)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(n, moneyFormat);
    }
    return '$' + (n / 100).toFixed(2);
  };

  // Build variant dropdown from featured_product.variants
  const variants = Array.isArray(product.variants) ? product.variants : [];
  if (!variants.length) {
    console.warn('Sticky ATC: No variants found for featured product');
    return;
  }

  // Pick a default variant (selected/first available)
  const firstAvailable = variants.find(v => v.available) || variants[0];
  
  // THIS IS THE CLEAN VERSION FOR VARIANTS - Dynamic
  // variantSelect.innerHTML = variants.map(v => {
  //   const sold = v.available ? '' : ' — Sold out';
  //   return `<option value="${v.id}" data-available="${v.available}" data-price="${v.price}" data-compare="${v.compare_at_price || 0}">
  //     ${escapeHtml(v.public_title || v.title || 'Default')}${sold}
  //   </option>`;
  // }).join('');

  // THIS SANITIZES TEXT FOR COLOR
  variantSelect.innerHTML = variants.map(v => {
  const sold = v.available ? '' : ' — Sold out';

  // Base label (what Shopify gives us)
  let label = (v.public_title || v.title || 'Default');

  // Remove the exact suffixes you mentioned (with or without leading "/ ")
  label = label
    //.replace(/\s*\/\s*Dual Voltage\s*$/i, '')
    .replace(/\s*\/\s*US Voltage Only\s*$/i, '')
    .trim();

  return `<option value="${v.id}"
    data-available="${v.available}"
    data-price="${v.price}"
    data-compare="${v.compare_at_price || 0}">
    ${escapeHtml(label)}${sold}
  </option>`;
}).join('');


  variantSelect.value = String(firstAvailable.id);

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function renderPriceFromOption(opt) {
    const price = opt.getAttribute('data-price');
    const compare = opt.getAttribute('data-compare');

    if (!priceWrap) return;

    const p = Number(price);
    const c = Number(compare);

    if (c && c > p) {
      priceWrap.innerHTML =
        `<span class="sticky-atc__price-current">${formatMoney(p)}</span>
         <span class="sticky-atc__price-compare">${formatMoney(c)}</span>`;
    } else {
      priceWrap.innerHTML =
        `<span class="sticky-atc__price-current">${formatMoney(p)}</span>`;
    }
  }

  function syncAvailability() {
    const opt = variantSelect.options[variantSelect.selectedIndex];
    if (!opt) return;

    const available = (opt.getAttribute('data-available') === 'true');

    submitBtn.disabled = !available;
    submitBtn.textContent = available ? 'Add to cart' : 'Sold out';

    renderPriceFromOption(opt);
  }

  // Qty buttons
  sticky.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const delta = Number(btn.getAttribute('data-qty'));
    const current = Math.max(1, Number(qtyInput.value || 1));
    qtyInput.value = Math.max(1, current + delta);
  });

  // Variant change
  variantSelect.addEventListener('change', syncAvailability);

  // Add to cart (uses selected variant id from featured_product)
  submitBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    const variantId = Number(variantSelect.value);
    const quantity = Math.max(1, Number(qtyInput.value || 1));

    submitBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      // If you have a cart drawer, trigger it here (theme-dependent).
      // Safe fallback: go to cart.
      window.location.href = '/cart';

    } catch (err) {
      console.error(err);
      submitBtn.disabled = false;
      syncAvailability();
    }
  });

  // Show/hide sticky
  const showSticky = () => sticky.classList.add('is-visible');
  const hideSticky = () => sticky.classList.remove('is-visible');

  if ('IntersectionObserver' in window && anchor) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) hideSticky();
        else showSticky();
      });
    }, { threshold: 0.05 });
    io.observe(anchor);
  } else {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) showSticky();
      else hideSticky();
    }, { passive: true });
  }

  // Init
  syncAvailability();
})();





(function($) {
    $(function() {
      var $section = $('#rb-product-hero');
      var productJsonEl = document.getElementById('ProductJson-rb-hero');
      if (!productJsonEl) {
        console.warn('ProductJson-rb-hero not found');
        return;
      }

      var rawJson = productJsonEl.textContent || productJsonEl.innerText || '';
      if (!rawJson.trim()) {
        console.warn('ProductJson-rb-hero is empty');
        return;
      }

      var productData;
      try {
        productData = JSON.parse(rawJson);
      } catch (e) {
        console.error('Invalid product JSON:', e);
        return;
      }

      // Make sure we actually have variants
      var variants = Array.isArray(productData.variants) ? productData.variants : [];
      if (!variants.length) {
        console.warn('No variants found on productData');
        return;
      }

      var $variantInput   = $('#rb-variant-id');
      var currentVariantId = parseInt($variantInput.val(), 10);
      var currentVariant   = variants.find(function(v) {
        return v.id == currentVariantId;
      }) || variants[0];

      // Clone the current variant options array so we can mutate it
      var currentOptions = currentVariant && Array.isArray(currentVariant.options)
        ? currentVariant.options.slice()
        : [];

      function findVariant() {
        if (!currentOptions.length) return null;

        return variants.find(function(variant) {
          if (!Array.isArray(variant.options)) return false;
          for (var i = 0; i < variant.options.length; i++) {
            if (currentOptions[i] !== variant.options[i]) {
              return false;
            }
          }
          return true;
        }) || null;
      }

      function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, "");
        }
        return (cents / 100).toFixed(2);
      }

      function updateUI(variant) {
        if (!variant) return;

        $variantInput.val(variant.id);
        // $('#rb-price').text(formatMoney(variant.price));

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          $('#rb-compare-price-wrap').removeClass('d-none');
          $('#rb-compare-price').text(formatMoney(variant.compare_at_price));
          var diff = variant.compare_at_price - variant.price;
          // $('#rb-savings').text('Save ' + formatMoney(diff));
        } else {
          $('#rb-compare-price-wrap').addClass('d-none');
        }

        var $btn = $('#rb-add-to-cart');
        if (variant.available) {
          $btn.prop('disabled', false).text('ADD TO CART');
          $('#rb-soldout-msg').addClass('d-none');
        } else {
          $btn.prop('disabled', true).text('Sold out');
          $('#rb-soldout-msg').removeClass('d-none');
        }
      }

      // Initialize UI
      updateUI(currentVariant);

      // Color selection
      $section.on('click', '.rb-color-swatch', function(e) {
        e.preventDefault();
        var $btn = $(this);
        if ($btn.hasClass('is-disabled')) return;

        var pos   = parseInt($btn.data('option-position'), 10);
        var value = $btn.data('option-value');

        if (isNaN(pos)) return;

        currentOptions[pos] = value;

        $btn
          .addClass('is-active')
          .parent().siblings().find('.rb-color-swatch').removeClass('is-active');

        $('#rb-color-label-value').text(value);
        if (value === 'Black') {
          $('#rb-color-tag').text('(Top Seller)');
        } else {
          $('#rb-color-tag').text('');
        }

        var variant = findVariant();
        if (variant) updateUI(variant);
      });

      // Voltage selection
      $section.on('click', '.rb-variant-btn-radio', function(e) {
        e.preventDefault();
        var $btn = $(this);
        if ($btn.hasClass('is-disabled')) return;

        var pos   = parseInt($btn.data('option-position'), 10);
        var value = $btn.data('option-value');

        if (isNaN(pos)) return;

        currentOptions[pos] = value;

        $btn
          .addClass('is-active')
          .attr('aria-checked', 'true')
          .siblings('.rb-variant-btn-radio')
          .removeClass('is-active')
          .attr('aria-checked', 'false');

        var variant = findVariant();
        if (variant) updateUI(variant);
      });

      // Quantity buttons
      $section.on('click', '.rb-qty-minus', function() {
        var $input = $section.find('.rb-qty-input');
        var val = parseInt($input.val() || '1', 10);
        if (val > 1) $input.val(val - 1);
      });

      $section.on('click', '.rb-qty-plus', function() {
        var $input = $section.find('.rb-qty-input');
        var val = parseInt($input.val() || '1', 10);
        $input.val(val + 1);
      });

      // Splide sliders (hardcoded IDs)
      function initHeroSplide() {
        if (typeof Splide === 'undefined') {
          setTimeout(initHeroSplide, 50);
          return;
        }

        var main = new Splide('#rb-product-gallery-main', {
          type      : 'loop',
          perPage   : 1,
          pagination: false,
          arrows    : true,
          gap       : '1rem'
        });

        var thumbs = new Splide('#rb-product-gallery-thumbs', {
          fixedWidth  : 80,
          fixedHeight : 80,
          gap         : 8,
		  arrows    : false,
          rewind      : true,
          isNavigation: true,
		  //perPage	  : 4,
          pagination  : false,
          focus       : 'left',
          breakpoints : {
            767: {
              fixedWidth : 64,
              fixedHeight: 64
            }
          }
        });

        main.sync(thumbs);
        main.mount();
        thumbs.mount();
      }

      initHeroSplide();
    });
})(jQuery);



(function($) {
	$(function() {
	function initToolsSlider() {
		if (typeof Splide === 'undefined') {
		// Splide not ready yet (in case of async load)
		setTimeout(initToolsSlider, 50);
		return;
		}

		var el = document.getElementById('rb-tools-slider');
		if (!el) return;

		var toolsSplide = new Splide('#rb-tools-slider', {
		type      : 'loop',
		perPage   : 4,
		gap       : '1.5rem',
		pagination: false,
		arrows    : true,
		breakpoints: {
			1199: { perPage: 3 },
			991 : { perPage: 2 },
			767 : { perPage: 1, gap: '1rem' }
		}
		});

		toolsSplide.mount();
	}

	initToolsSlider();
	});
})(jQuery);





// Before / After Slider
(function($) {
	$(function() {
	var $section   = $('#rb-results-section');
	var $viewer    = $('#rb-ba-viewer');
	var $handle    = $('#rb-ba-handle');
	var $beforeImg = $('#rb-ba-before-img');
	var $afterImg  = $('#rb-ba-after-img');
	var isDragging = false;

	// Helper: set position based on clientX
	function setPositionByClientX(clientX) {
		var rect = $viewer[0].getBoundingClientRect();
		var x    = clientX - rect.left;

		if (x < 0) x = 0;
		if (x > rect.width) x = rect.width;

		var pct = (x / rect.width) * 100;        // 0–100
		var rightPct = (100 - pct) + '%';

		// Clip the AFTER image from the right
		$afterImg[0].style.setProperty('--ba-right', rightPct);

		// Move handle
		$handle.css('left', pct + '%');
	}

	// Reset to 50/50
	function resetSlider() {
		$afterImg[0].style.setProperty('--ba-right', '50%');
		$handle.css('left', '50%');
	}

	// Mouse drag
	$handle.on('mousedown', function(e) {
		e.preventDefault();
		isDragging = true;
	});
	$(document).on('mousemove', function(e) {
		if (!isDragging) return;
		setPositionByClientX(e.clientX);
	});
	$(document).on('mouseup', function() {
		isDragging = false;
	});

	// Touch drag
	$handle.on('touchstart', function(e) {
		isDragging = true;
	});
	$(document).on('touchmove', function(e) {
		if (!isDragging) return;
		var touch = e.originalEvent.touches[0];
		setPositionByClientX(touch.clientX);
	});
	$(document).on('touchend touchcancel', function() {
		isDragging = false;
	});

	// Tap anywhere on viewer to jump handle
	$viewer.on('click', function(e) {
		if (!e.clientX) return;
		setPositionByClientX(e.clientX);
	});

	// Style tab clicks: swap images and reset slider
	$section.on('click', '.rb-style-tab', function() {
		var $btn   = $(this);
		var before = $btn.data('before');
		var after  = $btn.data('after');

		if (!before || !after) return;

		$btn.addClass('active')
			.siblings('.rb-style-tab')
			.removeClass('active');

		$beforeImg.attr('src', before);
		$afterImg.attr('src', after);

		resetSlider();
	});

	// Initial position
	resetSlider();
	});
})(jQuery);






document.addEventListener('DOMContentLoaded', () => {
  const wraps = document.querySelectorAll('.klarna-tip-wrap');

  function closeAll() {
    wraps.forEach(w => {
      const btn = w.querySelector('.klarna-btn');
      const tip = w.querySelector('.klarna-tip');
      if (!btn || !tip) return;
      tip.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  wraps.forEach(wrap => {
    const btn = wrap.querySelector('.klarna-btn');
    const tip = wrap.querySelector('.klarna-tip');
    if (!btn || !tip) return;

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = tip.hidden === false;
      closeAll();
      tip.hidden = isOpen; // toggle
      btn.setAttribute('aria-expanded', String(!isOpen));
    });

    // prevent inside tooltip clicks from closing immediately
    tip.addEventListener('click', (e) => e.stopPropagation());
  });

  document.addEventListener('click', () => closeAll());

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
});




















// Clear cart then push to Checkout (with discount + all URL params)
(function($) {
  $(function() {
    var $form = $('#rb-product-form');
    if (!$form.length) return;

    // Read existing URL params
    var searchParams    = new URLSearchParams(window.location.search);
    var discountFromUrl = searchParams.get('discount');

    // Fallback to a hardcoded discount if not present in URL
    var DISCOUNT_CODE = discountFromUrl || ''; // 6IOSAVETODAY <— code, or '' if none

    $form.on('submit', function(e) {
      e.preventDefault();

      var $btn     = $('#rb-add-to-cart');
      var formData = $form.serialize();

      // Optional: simple loading state
      $btn.prop('disabled', true).text('Please wait...');

      // 1) Clear the cart
      $.ajax({
        type: 'POST',
        url: '/cart/clear.js',
        dataType: 'json'
      })
      .always(function() {
        // 2) Add this variant with selected quantity
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formData,
          dataType: 'json',
          success: function() {
            // 3) Build checkout URL with all params + discount
            var params = new URLSearchParams(window.location.search);

            if (DISCOUNT_CODE) {
              // ensure/override discount in the param set
              params.set('discount', DISCOUNT_CODE);
            }

            var queryString = params.toString();
            var checkoutUrl = '/checkout' + (queryString ? '?' + queryString : '');

            window.location.href = checkoutUrl;
          },
          error: function(xhr) {
            console.error('Add to cart failed', xhr);
            alert('Something went wrong adding this item to your cart. Please try again.');
            $btn.prop('disabled', false).text('ADD TO CART');
          }
        });
      });
    });
  });
})(jQuery);











(function () {
  function buildYouTubeIframe(videoId) {
    var src =
      "https://www.youtube-nocookie.com/embed/" +
      encodeURIComponent(videoId) +
      "?autoplay=1&rel=0&modestbranding=1&playsinline=1";

    var iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.title = "YouTube video player";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.allowFullscreen = true;
    iframe.setAttribute("loading", "lazy");
    return iframe;
  }

  function init(el) {
    var poster = el.getAttribute("data-poster");
    var img = el.querySelector(".video-poster");
    if (img && poster) img.src = poster;

    function play() {
      if (el.getAttribute("data-playing") === "1") return;

      var videoId = el.getAttribute("data-video-id");
      if (!videoId) return;

      el.setAttribute("data-playing", "1");
      el.innerHTML = ""; // remove poster + play button
      el.appendChild(buildYouTubeIframe(videoId));
    }

    el.addEventListener("click", play);
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        play();
      }
    });
  }

  document.querySelectorAll(".video-container.js-yt").forEach(init);
})();




	
$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});

// document.addEventListener('DOMContentLoaded', function() {
//     const pack1Radio = document.getElementById('buy-pack1');
//     const pack2Radio = document.getElementById('buy-pack2');
//     const pack1Button = document.querySelector('.j-go.--pack1');
//     const pack2Button = document.querySelector('.j-go.--pack2');
//     const price1Text = document.querySelector('.s9_price.--pack1');
//     const price2Text = document.querySelector('.s9_price.--pack2');

//     function toggleButtons() {
//         if (pack1Radio.checked) {
//             pack1Button.style.display = 'inline-block';
//             price1Text.style.display = 'inline-block';
//             pack2Button.style.display = 'none';
//             price2Text.style.display = 'none';
//         } else if (pack2Radio.checked) {
//             pack1Button.style.display = 'none';
//             price1Text.style.display = 'none';
//             pack2Button.style.display = 'inline-block';
//             price2Text.style.display = 'inline-block';
//         }
//     }

//     // Run on load
//     toggleButtons();

//     // Add event listeners
//     pack1Radio.addEventListener('change', toggleButtons);
//     pack2Radio.addEventListener('change', toggleButtons);
// });


document.addEventListener('DOMContentLoaded', function() {
    let trackingFired = false;

    function trackPageView() {
        if (!trackingFired) {
			axon("track", "view_item", {
            	"currency": "USD",
            	"items": [
					{
						"price": "169.97",
						"item_name": "6-in-1 Hot Air Styler",
						"item_id": "9209418613055",
                        "item_variant_id": "50124658049343",
						"item_category_id": "469", // From Axon List 
						"quantity": "1",
						"image_url": "https://cdn.shopify.com/s/files/1/0684/7974/6367/files/Air_Styler_B0CN3XNVJT_Black_Amazon_Main_Image_Sept_2025.jpg?v=1760435644",
					}
				]
        		});
            console.log('Page view tracked adjusted');
            trackingFired = true;
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                trackPageView();
            }
        });
    }, {
        threshold: 0.05
    });

    const getOrderElement = document.getElementById('getOrder');
    if (getOrderElement) {
        observer.observe(getOrderElement);
    }

    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#getOrder").offset().top - 60
        }, 2000, function() {

            trackPageView();

        });
    });

    
    if (getOrderElement && getOrderElement.getBoundingClientRect().top < window.innerHeight) {
        trackPageView();
    }
});

function createOrSyncCookies() {
	const primaryCookieName = 'axwrt';   // This is the main cookie we'll sync others to.
	const secondaryCookieName = '_axwrt'; // Axon Cookie
	let userId = getCookieValue(primaryCookieName) || getCookieValue(secondaryCookieName) || generateUserId(); // Use existing or generate new.

	// Sync both cookies - set the same userId
	setCookie(primaryCookieName, userId, 365, '/');
	setCookie(secondaryCookieName, userId, 365, '/');

	console.log('Cookies synchronized with UserId:', userId);
}

function generateUserId() {
	return 'uid_' + Math.random().toString(36).substr(2, 9);
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return null;
}

function setCookie(name, value, days, path) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + value + expires + "; path=" + path;
}

createOrSyncCookies();




